/**
 * Calculate the correct permalink for an episode
 * @param {(string | number)} episodeId
 * @param {string} programmeGuid
 * @param {string} [path='episode'] - the first segment of the url
 * @param {string} episodeGuid
 */
export default function getEpisodeUrl({
  episodeId,
  programmeGuid,
  path = 'episode',
  episodeGuid,
}) {
  // middle segment is the episode ID converted to a base36 string
  const hash = parseInt(episodeId, 10).toString(36)
  const episodeGuidString = episodeGuid ? `/${episodeGuid}` : ''
  const programmeGuidString = programmeGuid ? `/${programmeGuid}` : ''
  return `/${path}/${hash}${programmeGuidString}${episodeGuidString}`
}
